import { Logger } from "./Logger";
import { tracker } from "./tracker/Tracker";
import { gatherVideoClientDataSource } from "./Globals";
export const debugMajorEvents = [];
const MAX_DEBUG_MAJOR_EVENTS = 4096;
export function debugLogMajorEvent(event) {
    debugMajorEvents.push({
        t: (gatherVideoClientDataSource.performance().now() / 1000).toFixed(2),
        event,
    });
    if (debugMajorEvents.length > MAX_DEBUG_MAJOR_EVENTS) {
        debugMajorEvents.shift();
    }
    Logger.info(event);
    tracker.captureMajorEvent(event);
}
//# sourceMappingURL=DebugLogger.js.map